import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { CONTACT_INFO } from '@/lib/data';

/**
 * Floating mobile-only "Book Now" bar. Slides in after the visitor scrolls
 * past the hero; hidden on booking/admin flows where it would be noise.
 */
export const MobileBookBar = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();
  const hidden = pathname.startsWith('/booking') || pathname.startsWith('/admin');

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 360);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (hidden) return null;

  return (
    <div
      data-testid="mobile-book-bar"
      className={`fixed bottom-0 inset-x-0 z-40 md:hidden transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full pointer-events-none'
      }`}
    >
      <div className="mx-4 mb-4 flex items-center gap-3 bg-[#131A2D]/95 backdrop-blur-md border border-[#C9A24A]/40 p-3 shadow-[0_10px_40px_rgba(0,0,0,0.55)]">
        <a
          href={`tel:${CONTACT_INFO.phoneRaw}`}
          data-testid="mobile-book-bar-call"
          aria-label={`Call ${CONTACT_INFO.phone}`}
          className="shrink-0 w-11 h-11 flex items-center justify-center border border-[#C9A24A]/40 text-[#C9A24A] hover:bg-[#C9A24A]/10 transition-colors"
        >
          <Phone size={17} />
        </a>
        <Link
          to="/booking"
          data-testid="mobile-book-bar-cta"
          className="btn-gold flex-1 text-center !py-3 text-xs tracking-[0.24em]"
        >
          BOOK NOW
        </Link>
      </div>
    </div>
  );
};
